/* eslint-disable unicorn/no-fn-reference-in-iterator */

/* eslint-disable unicorn/filename-case */
const getValueObject = selectedValue => option => (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.toString()) === ((option === null || option === void 0 ? void 0 : option.value) && option.value.toString());
const setDefaultValue = (options, selectedValue) => {
  if (!selectedValue) return undefined;
  const getCurrentOption = options === null || options === void 0 ? void 0 : options.find(getValueObject(selectedValue));
  if (getCurrentOption === undefined) return getCurrentOption;
  return getCurrentOption.value;
};
const constructLabelWithDescriptor = (label, descriptor) => {
  if (!label) return undefined;
  const descriptorLabel = descriptor ? ` - ${descriptor}` : '';
  return `${label}${descriptorLabel}`;
};

export { constructLabelWithDescriptor, getValueObject, setDefaultValue };
